/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Permissions {
    Employee_Get = 102001,
    Employee_Edit = 102002,
    Employee_Delete = 102003,
    Customer_Get = 103001,
    Customer_Edit = 103002,
    Customer_Delete = 103003,
    Customer_Create = 103004,
    Product_Get = 105001,
    Product_Edit = 105002,
    Product_Delete = 105003,
    Other_GlobalEventLog_SelectIdentity = 106025,
    Technical_SetUIVersion = 107001,
    Technical_SetUIPermissions = 107002,
    Technical_SetTopBarBackgroundColor = 107003,
    MenuItem_Customer = 108002,
    MenuItem_Profile = 108004,
    MenuItem_Employee = 108006,
    MenuItem_FAQ = 108007,
    MenuItem_Attribute = 108012,
    MenuItem_SystemSettings = 108019,
    MenuItem_Instruction = 108021,
    MenuItem_Product = 108022,
    MenuItem_PriceList = 108023,
    MenuItem_GlobalEventLog = 108024,
    MenuItem_Project = 108025,
    MenuItem_Product_Type = 108026,
    MenuItem_Customer_Price_Group = 108027,
    MenuItem_Customer_Sales_Person_Role = 108028,
    MenuItem_Customer_Payment_Term = 108029,
    MenuItem_UserSettings = 108030,
    MenuItem_Document_Type = 108031,
    MenuItem_UserRoles = 108032,
    MenuItem_Configurator_List = 108033,
    MenuItem_Configurator_Rule = 108034,
    MenuItem_Import_From_BC = 108035,
    MenuItem_Import_CSV = 108036,
    MenuItem_Configurator_System_Package = 108037,
    MenuItem_Configurator_Matrix = 108038,
    Project_Delete = 110001,
    Configurator_Attribute_Edit = 111001,
    Configurator_Attribute_Delete = 111002,
    Configurator_Attribute_Create = 111003,
    Configurator_Rule_Edit = 112001,
    Configurator_Rule_Delete = 112002,
    Configurator_Rule_Create = 112003,
    Data_Import_Contact_Person = 113001,
    Data_Import_Customer = 113002,
    Data_Import_NAV_Invoice = 113003,
    Data_Import_Product_Price = 113004,
    /**
     * Increment by 1 inside each PermissionGroup number range.///
     */
    SomeThingZYX = 201001,
    /**
     * permission for permissionGroup
     */
    SomeThingZYXBLA = 201002,
    /**
     * Update User
     */
    UpdateUser = 301001,
    /**
     * Create Role
     */
    CreateRole = 301002,
}
